import { type Configuration, PublicClientApplication } from "@azure/msal-browser";
import { initializeMsalInstance } from "@haskoning/msal";

// MSAL Configuration
const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: "https://login.microsoftonline.com/15f996bf-aad1-451c-8d17-9b95d025eafc",
    redirectUri: globalThis.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
  },
};

// Authentication Request Configuration
export const loginRequest = {
  scopes: [import.meta.env.VITE_AZURE_AUDIENCE],
};

// Initialize the MSAL instance
export const msalInstance: PublicClientApplication = await initializeMsalInstance(msalConfig);
